// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { cilXCircle } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import { CFormInput } from "@coreui/react-pro";
import PropTypes from "prop-types";

const Input = ({ value = "", __FormItem = true, style = undefined, ...props }) => {
  return (
    <div className={"position-relative"} style={style}>
      <CFormInput
        value={value}
        {...props}
        onChange={(e) => {
          props.onChange(e);
        }}
      />
      {props.allowClear && (
        <span
          className={"position-absolute top-50 end-0 translate-middle search-control__clear"}
          color={"secondary"}
          variant={"outline"}
          onClick={() => props.onChange({ target: { value: undefined } })}
        >
          <CIcon icon={cilXCircle} />
        </span>
      )}
    </div>
  );
};

Input.propTypes = {
  value: PropTypes.string,
  __FormItem: PropTypes.bool,
};

Input.defaultProps = {
  __FormItem: true,
};

export default Input;
